const Routes = {
  home: "/",
  categoryBusinesses: "/category/:id",
  business: "/business/:id",
};

export default Routes;
